//#region src/config/const.ts
const defaultGlobalObjectKey = "faro";
const defaultBatchingConfig = {
	enabled: true,
	sendTimeout: 250,
	itemLimit: 50
};
//#endregion
export { defaultBatchingConfig, defaultGlobalObjectKey };

//# sourceMappingURL=const.js.map